<template>
  <div class="header" :class="theme" :style="customStyle">
    <img class="header__logo" :src="logoSrc" alt="" />
    <div class="header__div">
      <div class="header__loginText">{{ loginNavBarText }}</div>
      <span class="header__product">{{ customer }}</span>
    </div>
    <ul class="header__buttons" v-if="loggedIn">
      <li class="header__list" v-for="button in buttons" :key="button.name">
        <p4a-button
          :showIcon="true"
          :onlyIconVisible="true"
          :icon="button.icon"
          :size="'large'"
          :disable="false"
          @click="button.function"
          :text="'Afsluiten'">
        </p4a-button>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    props: {
      product: String,
      customer: String,
      buttons: Array,
      loggedIn: Boolean,
      background: String,
      hoverColor: String,
      loginNavBarIcon: String,
      loginNavBarText: String,
      fontColor: String
    },
    computed: {
      customStyle () {
        return {
          '--background-color': this.background,
          '--hover-color': this.hoverColor,
          '--font-color': this.fontColor ? this.fontColor: 'white' 
        }
      },
      theme () {
        return (this.background || this.hoverColor) ? 'custom' : this.product; 
      },
      logoSrc () {
        return (!this.loginNavBarIcon) ? require('../img/' + this.product + '-header-logo.svg') : this.loginNavBarIcon;
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../styling/styling.scss';

  $themes: (
    ds: ($docstream, $docstream-hover),
    sns: ($snagstream, $snagstream-hover),
    ls: ($leanstream, $leanstream-hover),
    bms: ($bimstream, $bimstream-hover),
    portal: ($portal, $portal-hover),
    as: ($asstream, $asstream-hover),
    tbq: ($tbq, $tbq-hover),
    custom: (var(--background-color), var(--hover-color))
  );

  .btn-icon { color: $white; }

  .header {
    width: 100%;
    height: rem(50);
    position: relative;

    &__logo {
      height: rem(32);
      float: left;
      display: block;
      margin: rem(9) rem(15);
    }

    &__product {
      height: rem(50);
      right: 50%;
      color: var(--font-color);
      font-weight: 500;
      font-size: rem(17);
      text-align: center;
      position: absolute;
      line-height: rem(50);
      transform: translate(50%, 0);
    }

    &__loginText {
      height: rem(50);
      color: var(--font-color);
      font-weight: 500;
      font-size: rem(17);
      text-align: center;
      line-height: rem(50);
      display: inline-block;
      float: left;
    }

    &__div {
      width:100%;
      text-align: center;
    }
    
    &__buttons { float: right; }

    &__list {
      width: rem(50);
      height: rem(50);
      cursor: pointer;
      display: inline-block;

      .btn { color: $white; }
    }

    @each $name, $colors in $themes {
      $color: nth($colors, 1);
      $backgroundHover: nth($colors, 2);

      &.#{$name} {
        background-color: $color;

        .btn {
          margin: 0;
          border-radius: 0;

          &:hover { background-color: $backgroundHover; }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Header.vue